import { useEffect } from 'react'
import { Input } from 'components'
import Flex from 'components/priority/Flex/Flex'
import * as S from './Slider.styled'

export const Slider = ({
  sliderState: [value, setValue] = [null, () => {}],
  min,
  max,
  initialValue,
  ...rest
}) => {
  useEffect(() => {
    const valueIsMissing = value === undefined || value === null || value === ''
    if (valueIsMissing) {
      setValue(initialValue)
    }
    // eslint-disable-next-line
  }, [initialValue, value])

  const handleSliderChange = (e) => {
    const { value: sliderValue } = e.target
    setValue(Number(sliderValue))
  }

  const handleInputChange = (e) => {
    let inputValue = e.target.value
    const isEmpty = inputValue === ''
    if (!isEmpty) {
      inputValue *= 1
    }
    const isNumber = typeof inputValue === 'number'
    const over = inputValue !== '' && inputValue > max * 1
    const under = inputValue !== '' && inputValue < min * 1
    if (over) {
      inputValue = max * 1
    }
    if (under) {
      inputValue = min * 1
    }
    if (isNumber || isEmpty) setValue(isEmpty ? '' : inputValue)
  }

  return (
    <Flex full align="center" {...rest}>
      <S.Slider
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={handleSliderChange}
      />
      <Input
        width="84px"
        margin="0 0 0 16px"
        value={[parseInt(value)]}
        onChange={handleInputChange}
        type="number"
      />
    </Flex>
  )
}

export default Slider
